var reviewsList = vueIfExists({
	mixins: [win.toggleCollapse],
	el: '#reviews-list',
	data: {
		sharedState: store.state,
		reviews: [],
		scores: {},
		languages: [],
		rating: null,
        handle: null,
        panelCollapsed: {
            'search-filter': true,
        },
        loading: false,
        noResults: false,
        query: {
        	purpose: null,
        	kindTraveler: null,
        	reviewLang: 'en'
        },
        cache: {
            handle: null,
            query: {},
            expiresSec: 5 * 60,
            time: 0,
            offset: 0
        },
        offset: 0,
        limit: 15,
        listTotal: 0,
        filterTotals: {
        	purpose: [],
        	kindTraveler: []
        }
	},
	computed: {
	    paginatorPages: function() {
            var maxPages = 10,
                totalPages = Math.ceil(this.listTotal / this.limit),
                currentPage = Math.floor(this.offset / this.limit),
                pageIndex = currentPage - 1;
                pages = [currentPage];

            while (pageIndex >= 0 && pageIndex >= currentPage - 5) {
                pages.unshift(pageIndex--);
            }
            pageIndex = currentPage + 1;
            while (pageIndex < totalPages && ( pageIndex <= currentPage + 5 || pages.length < 10)) {
                pages.push(pageIndex++);
            }
            pageIndex = pages[0] -1;
            while (pageIndex >= 0 && pages.length < 10) {
                pages.unshift(pageIndex--);
            }
            return pages;
        }
	},
    mounted: function() {
        this.initReviewList();
        window.addEventListener('popstate', this.onHistoryChange);
    },
	methods: {
        initReviewList: function() {
            this.setOffset($url.getVar('offset'));
            this.query = {
            	purpose: $url.getVar('purpose'),
            	kindTraveler: $url.getVar('kind_traveler'),
            	reviewLang: $url.getVar('reviewlang') || 'en'
            };
            this.getReviews({
                query: this.query,
                offset: this.offset
            });
			this.setCheckboxes('purpose', this.query.purpose, 8);
			this.setCheckboxes('kindtraveler', this.query.kindTraveler, 7);
        },
        setCheckboxes: function(checkboxId, checkedStr, total) {
            var $checkbox;
            checkedStr = checkedStr || '';
            var checkedArr = checkedStr.split('');
            for (var checkbox = 1; checkbox <= total; checkbox++) {
                $checkbox = gE(checkboxId+"_"+checkbox);
                if ($checkbox) $checkbox.checked = checkedArr.indexOf(checkbox.toString()) != -1;
            }
            $checkbox = gE(checkboxId+"_all");
            if ($checkbox) $checkbox.checked = !checkedStr;
        },
        changeForm: function(event) {
        	if (event.target.id == 'purpose_all') {
        		this.setCheckboxes('purpose', '', 8);
        	}
        	if (event.target.id == 'kindtraveler_all') {
        		this.setCheckboxes('kindtraveler', '', 7);
        	}
            if (gE("purpose_all")) gE("purpose_all").checked = !this.getCheckedItems('purpose', 8).length;
            if (gE("kindtraveler_all")) gE("kindtraveler_all").checked = !this.getCheckedItems('kindtraveler', 7).length;
            this.submit();
        },
        getReviews: function(config) {
            var cacheIsExpired = (new Date().getTime() / 1000 - this.cache.time) > this.cache.expiresSec,
                hasCachedJson = JSON.stringify(config.query) == JSON.stringify(this.cache.query) && config.offset == this.cache.offset,
                requiresRequest = (!hasCachedJson || cacheIsExpired);

            if (requiresRequest) {
                this.loading = true;
                this.handle = win.$ajax.getJson({
                    url: win.jsonUrl.hotelReviews,
                    params: {
                    	q : $url.encodeQ(config.query), 
                    	offset: this.offset, 
                    	limit: this.limit,
                    	lang: this.sharedState.locale
                    },
                    abort: this.handle,
                    scope: this,
                    success: function(json) {
                        this.cache.query = JSON.parse(JSON.stringify(config.query));
                        this.listTotal = json.totalReviews;
                        this.setOffset(config.offset);
                        this.cache.offset = this.offset;
                        this.cache.time = new Date().getTime() / 1000;
                        win.store.set('errorType', json.errorType);
                        this.showResults(json);
                    },
                    failed: function(errorType) {
                        this.hotels = [];
                        win.store.set('errorType', errorType ? errorType : null);
                    },
                    always: function() {
                        this.loading = false;
                        if (config.callback) config.callback.call(config.scope);
                    }
                }); 
            } else {
                if (config.callback) config.callback.call(config.scope);
            }
    
        },
        showResults: function(json) {
            this.reviews = json.reviews;
            this.rating = json.rating;
            this.scores = json.scores;
			this.languages = json.languages;

            this.filterTotals = json.filterTotals;
            if (!this.listTotal && !this.sharedState.errorType) {
                win.store.set('errorType', 'noResults');
            }
        },
        setReviewLang: function(lang) {
        	this.query.reviewLang = lang; 
        	this.submit();
        },
        submit: function(event) {
        	if (event) {
                event.preventDefault();
            }
			this.query.purpose = this.getCheckedItems('purpose', 8).join('');
			this.query.kindTraveler = this.getCheckedItems('kindtraveler', 7).join('');
            this.getReviews({
                query: this.query,
                offset: this.offset,
                scope: this,
                callback: this.updateHistory
            });

        },
        getCheckedItems: function(checkboxId, total) {
        	var checked = [];
			var $el;
			for(var i=1; i<=total; i++) {
				$el = gE(checkboxId+'_'+i);
				if ($el && $el.checked) {
					checked.push(i);
				}
			}
			return checked;
        },	
        updateHistory: function() {
            var urlParams = { 
                    purpose: this.query.purpose,
                    kind_traveler: this.query.kindTraveler,
                    reviewlang: this.query.reviewLang,
                    offset: this.offset 
                },
                strUrl = $url.encodeVar( urlParams, { url: win.internalUrl.hotelReviews });
            win.history.pushState(urlParams, '', strUrl);
        },
        onHistoryChange: function() {
            this.initReviewList();
        },
        togglePanel: function(event) {
            this.toggleCollapse(event);
        },


        setOffset: function(offset) {
            offset = offset || 0;
            if (typeof offset == "string") offset = parseInt(offset);
            if (offset < 0) offset = 0;
            if (this.listTotal && offset >= this.listTotal) {
                offset = Math.floor(this.listTotal / this.limit) * this.limit;
            }
            if (offset % this.limit !== 0) {
                offset = Math.floor(offset / this.limit) * this.limit;
            }
            this.offset = offset;
        },
        submitOffset: function(offset) {
            this.setOffset(offset);
            this.submit();
            $d.scrollto({ distance: win.isMobile ? 0 : -gE('header-hotel-fixed').offsetHeight, 
            	toElement: document.querySelector('.result-list-title')});
        },
	
		reviewPopup: function(reviewId) {
			win.popup.show($url.encodeVar({
				strLang: this.sharedState.locale,
				reviewId: reviewId,
				hotel_id: this.sharedState.dsti
			}, { url: win.internalUrl.reviewPopup }),
			'',
			{ height: 450 });
		},
		translatedMessage: function(lang) {
        	return this.i18n.reviewTranslated.replace('%0%', lang).replace('%1%', '');
        }
	}
});